// extracted by mini-css-extract-plugin
export default {"audioVisualizer":"AudioVisualizer_audioVisualizer__-k1bW","visualizerCanvas":"AudioVisualizer_visualizerCanvas__l1zPi","timer":"AudioVisualizer_timer__HKZC7"};